export default "__VITE_ASSET__DbVbrMCY__"